import React, { useContext, useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { getGlobalTimePeriods } from 'gqlQueries/filterQueries';

const errorMessage: string = 'Something went wrong!';

function useFetchTimePeriodFilter() {
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>({});

    //To fetch dim
    const [getTimePeriodFilter, { data: timePeriod, loading: timePeriodLoading, error: timePeriodError }] =
        useLazyQuery(getGlobalTimePeriods, {
            onCompleted: onFetchComplete,
            onError: onFetchError,
        });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            let list: any = [...payload.getGlobalTimePeriods];
            list.push({
                timePeriod: 'Custom Date',
                startTimestamp: 0,
                endTimestamp: 0,
            });

            setData(list);
        } catch (error) {
            console.error(errorMessage, error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        //sending empty data to error to avoid null data being sent
        setData([]);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        fetchTimePeriodFilter: (variables: any) => {
            setData([]);
            setLoading(true);
            getTimePeriodFilter({ variables });
        },
    };
}

export default useFetchTimePeriodFilter;
